import {
  AdaptiveModal,
  Box,
  Button,
  formatPhoneNumberForDisplay,
  OTPInputField,
  Typography,
} from "@luce/ui";

import { useDeleteAccountContext } from "../delete-account-context";
import { formatCountdown, OTP_LENGTH } from "../lib";

export function DeleteAccountOtpModal() {
  const {
    step,
    phoneNumber,
    pinCode,
    otpError,
    remaining,
    isConfirmingOtp,
    isSendingOtp,
    setPinCode,
    confirmOtp,
    resendOtp,
    close,
  } = useDeleteAccountContext();

  const handleOpenChange = (next: boolean) => {
    if (!next) close();
  };

  return (
    <AdaptiveModal.Root open={step === "otp"} onOpenChange={handleOpenChange} dialogSize="sm">
      <AdaptiveModal.Header>
        <AdaptiveModal.Title>OTP Verification</AdaptiveModal.Title>
        <AdaptiveModal.Description>
          {`A verification code has been sent to ${formatPhoneNumberForDisplay(phoneNumber)}.`}
        </AdaptiveModal.Description>
      </AdaptiveModal.Header>

      <AdaptiveModal.Body>
        <Box className="gap-spacing-md flex flex-col items-center">
          <OTPInputField
            length={OTP_LENGTH}
            value={pinCode}
            onChange={setPinCode}
            state={otpError ? "error" : "default"}
          />
          {otpError ? (
            <Typography variant="body-sm" color="system-danger-default" align="center">
              {otpError}
            </Typography>
          ) : null}
          {remaining > 0 ? (
            <Typography variant="body-sm" color="neutral-foreground-intermediate" align="center">
              {`Remaining time: ${formatCountdown(remaining)}`}
            </Typography>
          ) : (
            <Box className="flex flex-col items-center">
              <Typography variant="body-sm" color="neutral-foreground-intermediate" align="center">
                Didn&apos;t get the code?
              </Typography>
              <Button
                variant="tertiary"
                size="sm"
                label="Resend Code to SMS and WhatsApp"
                loading={isSendingOtp}
                onClick={resendOtp}
              />
            </Box>
          )}
        </Box>
      </AdaptiveModal.Body>

      <AdaptiveModal.Footer layout="stacked">
        <Button
          size="lg"
          fullWidth
          label="Confirm"
          loading={isConfirmingOtp}
          onClick={confirmOtp}
        />
      </AdaptiveModal.Footer>
    </AdaptiveModal.Root>
  );
}
